import { apiClient } from '@/lib/api.ts'

export function testEgisConnection() {
  return apiClient.get('/egis/test')
}
